<template>
  <div class="mx-10 ma-5">
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <div>
      <v-card flat class="pa-5">
        <PageTitleWithSearch
          :title="'Taxes'"
          :btnName="'Add New Tax'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/taxes/create'"
          :btnPermission="'productTax.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        />
        <DataTableWithPagination
          :headers="headers"
          :items="taxes"
          :loading="loading"
          :page="page"
          :total="total"
          @pageChange="page = $event"
        >
          <template #row="{ item}">
            <tr :key="item.uuid">
              <td class="text-left">{{ item.tax_code }}</td>
              <td class="text-left">{{ item.name }}</td>
              <td class="text-left">{{ item.rate }}</td>
              <td class="text-left">{{ item.status }}</td>
              <td class="text-center">
                <v-btn
                  class="ma-1"
                  color="#FFE0B2"
                  :to="'/taxes/edit/' + item.uuid"
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  color="#FFCDD2"
                  @click="dropTaxConfirm(item.uuid)"
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#F44336">mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </DataTableWithPagination>
      </v-card>
    </div>
    <ConfirmModal
      :text="'Do you want to drop this tax?'"
      :title="'Drop Tax'"
      :color="'red'"
      :confirmOpen="confirmOpen"
      @cancelConfirm="cancelConfirm"
      @confirm="confirm"
    />
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="snackbarColor"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import ConfirmModal from "@/components/shared/ConfirmModal";
import Snackbars from "@/components/shared/Snackbars";
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import { TaxService } from "@/services/tax-service.js";
import { checkError } from "@/config/errors.js";
import Alert from "@/components/shared/Alert.vue";

export default {
  name: "TaxGrid",
  components: {
    PageTitleWithSearch,
    ConfirmModal,
    Snackbars,
    DataTableWithPagination,
    Alert,
  },
  data() {
    return {
      taxes: [],
      page: 1,
      search: "",
      loading: false,
      total: 0,
      dropId: null,
      confirmOpen: false,
      errors: null,
      snackbar: false,
      successMsg: "",
      snackbarColor: "warning",
      headers: [
        { text: "Tax Code", value: "tax_code", align: "start" },
        { text: "Name", value: "name", align: "start" },
        { text: "Rate (%)", value: "rate", align: "start" },
        { text: "Status", value: "status", align: "start" },
        { text: "Action", value: "actions", align: "center" },
      ],
    };
  },
  mounted() {
    this.getTaxes();
  },
  watch: {
    search(newSearch) {
      this.getTaxes(newSearch);
    },
    page() {
      this.getTaxes(this.search);
    },
  },
  methods: {
    async getTaxes(search = "") {
      this.loading = true;
      try {
        const response = await TaxService.getTaxes(search, this.page);
        this.taxes = response.data?.data || [];
        this.total = response.data?.meta?.last_page || 0;
      } catch (error) {
        this.taxes = [];
        let data = error.response?.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loading = false;
      }
    },
    searchChange(event) {
      this.search = event;
    },
    dropTaxConfirm(uuid) {
      this.dropId = uuid;
      this.confirmOpen = true;
    },
    cancelConfirm() {
      this.confirmOpen = false;
    },
    confirm() {
      this.confirmOpen = false;
      this.dropTax();
    },
    async dropTax() {
      if (this.dropId) {
        this.loading = true;
        try {
          await TaxService.deleteTax(this.dropId);
          this.getTaxes();
          this.snackbarColor = "success";
          this.successMsg = "Tax dropped successfully";
          this.snackbar = true;
        } catch (error) {
          let data = error.response?.data?.message || "Unknown error";

          let errorOutput = checkError.errorFormatting(data);
          let errorsArray = [];
          if (Array.isArray(errorOutput)) {
            errorsArray = errorOutput.filter((e) => !!e && e.trim());
            if (errorsArray.length === 0) errorsArray = [data];
          } else if (errorOutput && errorOutput.trim()) {
            errorsArray = [errorOutput];
          } else {
            errorsArray = [data];
          }
          this.errors = errorsArray;
        } finally {
          this.loading = false;
        }
      }
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    onDismissed() {
      this.errors = null;
    },
  },
};
</script>
